import axiosClient from "@/libs/axiosClient";

export const purgeCache = (purgeData) => {
    return axiosClient.post(`/edges/purgecache`, purgeData);
};

export const purgeBucket = (bucketData) => {
    return axiosClient.post(`/edges/deletebucketrecord`, {
        ...bucketData,
        ruleType: bucketData.ruleType || "waf",
    });
};

// export const getLogFromEdge = (data) => {
//     return axiosClient.post(`/edges/getlogfromedge`, data);
// };

export const getEdgeVersion = (data) => {
    return axiosClient.post(`/edges/edgeVersion`, data);
};

export const changeEdgeVersion = (data) => {
    return axiosClient.post(`/edges/edgeVersion/change`, data);
};

export const restartNginxMasterProcess = (data) => {
    return axiosClient.post(`/edges/restartnginxmasterprocess`, data);
};



// WEBPACK FOOTER //
// ./src/api/edges.js